export const fallBackRouteSchemaKey = "@default";

export type FallBackRouteSchemaKey = typeof fallBackRouteSchemaKey;
